<template>
  <div>
    <el-dialog
      :title="submitMode"
      :visible.sync="dialogFormVisible"
      :before-close="closeEventDialog"
    >
      <el-form :model="form" ref="form" label-position="top">
        <el-row :gutter="15" style="display: flex; gap: 5px">
          <el-col :span="13">
            <el-form-item
              label="Descripción"
              prop="title"
              :rules="[
                {
                  required: true,
                  message: 'La Descripción del evento es requerido',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input
                v-model="form.title"
                :disabled="eventSelectedIsTask"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item
              label="Monto"
              :rules="[
                { required: true, message: 'El monto es requerido' },
                { type: 'number', message: 'Solo se permite ingresar números' }
              ]"
            >
              <input type="number" v-model="form.amount" class="inputAmount" />
              <!-- =
              <input v-model="amountoFormat" disabled class="inputAmount" /> -->
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              label="Tipo de Factura"
              prop="invoiceType"
              :rules="[{ required: true, message: 'El tipo es requerido' }]"
            >
              <InvoiceType
                :initialValue="form.invoiceType"
                @OnInvoiceTypeSelected="OnInvoiceTypeSelected"
              />
            </el-form-item>
          </el-col>

          <!-- <el-col class="text-center" :span="5">
            <el-form-item label="Tipo">
              <el-select
                v-model="form.agendaType"
                placeholder="Evento"
                :disabled="eventSelectedIsTask"
              >
                <el-option
                  v-for="item in agendaTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-form-item label="Descripción">
          <quill-editor
            ref="myQuillEditor"
            v-model="form.description"
            style="height: 275px; margin-bottom: 10%"
          />
        </el-form-item> -->
        <!-- <el-row>
          <el-form-item label="Responsable de Tarea" prop="responsible"
          :rules="[
            {
              required: true,
              message: 'Elija el responsable de la tarea',
              trigger: 'blur'
            }
          ]"
          >
            <EmployeeSelector
              placeholder="Empleados"
              :DireccionParams="46"
              @selection-change="OnEmployeeSelected"
              size="small"
            />
          </el-form-item>
        </el-row> -->
        <el-form-item
          v-if="submitMode == 'Editar Fecha de Facturación'"
          label="Fecha de facturación"
          prop="endDate"
          :rules="[
            {
              required: true,
              message: 'Inserta una fecha válida',
              trigger: 'blur'
            }
          ]"
        >
          <el-col :span="11">
            <el-date-picker
              type="date"
              format="dd-MM-yyyy"
              placeholder="Fecha"
              v-model="form.endDate"
              style="width: 100%"
              :disabled="
                (eventSelectedIsTask && !userIsSupervisor) || !form.editionSerie
              "
              :picker-options="pickerOptionsEdit"
            ></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item
          v-if="submitMode == 'Editar Fecha de Pago'"
          label="Fecha de pago"
          prop="endDatePayment"
          :rules="[
            {
              required: true,
              message: 'Inserta una fecha válida',
              trigger: 'blur'
            }
          ]"
        >
          <el-col :span="11">
            <el-date-picker
              type="date"
              format="dd-MM-yyyy"
              placeholder="Fecha"
              v-model="form.endDatePayment"
              style="width: 100%"
              :disabled="
                (eventSelectedIsTask && !userIsSupervisor) || !form.editionSerie
              "
              :picker-options="pickerOptionsEdit"
            ></el-date-picker>
          </el-col>
        </el-form-item>

        <el-row style="display: flex; gap: 5px">
          <el-form-item
            v-if="submitMode == 'Agregar Facturación y Fecha de Pago'"
            label="Fecha de facturación"
            prop="endDate"
            :rules="[
              {
                required: true,
                message: 'Inserta una fecha válida',
                trigger: 'blur'
              }
            ]"
          >
            <el-col :span="25">
              <el-date-picker
                type="date"
                format="dd-MM-yyyy"
                placeholder="Hora"
                v-model="form.endDate"
                style="width: 100%"
                :disabled="eventSelectedIsTask && !userIsSupervisor"
              ></el-date-picker>
            </el-col>
          </el-form-item>

          <el-form-item
            v-if="
              submitMode != 'Editar Fecha de Pago' &&
              submitMode != 'Editar Fecha de Facturación'
            "
            label="Fecha de pago"
            prop="endDatePayment"
            :rules="[
              {
                required: true,
                message: 'Inserta una fecha válida',
                trigger: 'blur'
              }
            ]"
          >
            <el-col :span="24">
              <el-date-picker
                type="date"
                format="dd-MM-yyyy"
                placeholder="Fecha"
                v-model="form.endDatePayment"
                style="width: 100%"
                :disabled="eventSelectedIsTask && !userIsSupervisor"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item
            label="Tiempo Estimado"
            class="formItemTopPad"
            :rules="[
              {
                required: true,
                message: 'Debes asignar tiempo',
                trigger: 'blur'
              },
              {
                type: 'number',
                min: 0.5,
                message: 'El tiempo minimo debe ser igual o mayor a 0.5 horas',
                trigger: 'blur'
              }
            ]"
            prop="Time"
          >
            <!-- <el-input-number
              size="large"
              v-model="form.Time"
              :min="0"
              :controls="false"
            ></el-input-number> -->
            <TimeSelector
              :timeToEdit="form.Time"
              :defaultTime="2"
              size="large"
              :isDisabled="true"
              @TimeSelected="onTimeSelected"
            />
          </el-form-item>
          <el-form-item
            label="Minutos / Horas"
            class="formItemTopPad"
            prop="MinutesHours"
          >
            <MinuteOurSelectoForTasks
              size="large"
              FixedMinuteHour="m"
              :MinuteHour="form.minutesHours"
              :disabled="true"
              @MinuteHoureChanged="MinuteHoureChanged"
            />
          </el-form-item>
        </el-row>
        <el-row>
          <el-alert
            v-if="
              (form.Time > 8 && form.minutesHours === 'h') ||
              (form.Time > 480 && form.minutesHours === 'm')
            "
            type="error"
            title="Error de tiempo estimado"
            description="El tiempo No puede ser mayor a 8 horas o su equivalente 480 minutos"
            show-icon
          ></el-alert>
        </el-row>
        <el-row>
          <el-col class="ml-15" :span="6">
            <el-form-item
              label="Editar serie: "
              v-if="submitMode != 'Agregar Facturación y Fecha de Pago'"
            >
              <el-switch
                v-model="form.editionSerie"
                active-color="#34848BFF"
                active-text="Un mes"
                inactive-color="#34848BFF"
                inactive-text="Todos los meses"
                @change="onSwitchChange"
              ></el-switch>
            </el-form-item>
            <!-- v-if="submitMode != 'Agregar Facturación y Fecha de Pago'" -->
          </el-col>
          <el-col class="ml-15" :span="6">
            <el-form-item
              label="Tipo de Pago: "
              v-if="
                submitMode === 'Agregar Facturación y Fecha de Pago' ||
                submitMode === 'Agregar Fecha de Pago'
              "
            >
              <el-switch
                v-model="form.type"
                active-color="#34848BFF"
                active-text="Un mes"
                inactive-color="#34848BFF"
                inactive-text="Todos los meses"
                @change="onSwitchChange"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col class="ml-15" :span="6">
            <el-form-item :label="calculateSwitches">
              <el-switch
                v-model="form.paid"
                active-text="Ejecutado"
                inactive-text="Sin Ejecutar"
                active-color="#368939"
                inactive-color="#ff352e"
                :disabled="!form.editionSerie"
              ></el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              label="Fijar en Reportede tareas"
              class="formItemTopPad"
              prop="fixed"
            >
              <el-checkbox
                size="medium"
                v-model="form.fixed"
                :checked="form.fixed"
                @change="onFixedChange"
                >Fija?
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEventDialog">Cancelar</el-button>
        <el-button
          v-if="
            submitMode != 'Agregar Facturación y Fecha de Pago' &&
            submitMode != 'Agregar Fecha de Pago'
          "
          type="danger"
          @click="openDeleteDialog"
          v-loading="loading"
          >Eliminar</el-button
        >
        <el-button
          type="primary"
          @click="submitEvent"
          :disabled="
            disableBtn ||
            (form.Time > 8 && form.minutesHours === 'h') ||
            (form.Time > 480 && form.minutesHours === 'm')
          "
          v-loading="loading"
          v-if="
            rulesForDisablingSaveButton ? !rulesForDisablingSaveButton : true
          "
          >Guardar</el-button
        >
      </span>
    </el-dialog>
    <!-- Event Delete Dialog -->
    <el-dialog
      title="Confirmación de eliminación"
      :visible.sync="deleteConfirmationVisible"
      width="30%"
    >
      <span v-if="!form.editionSerie"
        >¿Está seguro/a de que desea eliminar este evento de todos los meses en
        que existe?</span
      >
      <span v-if="form.editionSerie"
        >¿Está seguro/a de que desea eliminar este evento en el mes
        seleccionado?</span
      >
      <br />
      <span>Esta acción no puede ser revertida</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="deleteConfirmationVisible = false"
          v-loading="loading"
          >Cancelar</el-button
        >
        <el-button type="danger" @click="handleDeleteEvent" v-loading="loading"
          >Eliminar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment-timezone";
// import { quillEditor } from "vue-quill-editor";
import { formatMonto } from "@/utils";
import MinuteOurSelectoForTasks from "@/components/cmi/ObjectivesReport/MinuteOurSelectoForTasks";
import TimeSelector from "@/components/cmi/ObjectivesReport/TimeSelector";
import InvoiceType from "@/components/calendar/selectors/InvoiceType";

export default {
  name: "CalendarFinancesEventForm",
  props: {
    form: {
      type: Object,
      default: function () {
        return {
          title: "",
          description: "",
          allDay: true,
          paid: false,
          type: true,
          //responsible: 0,
          startDate: "",
          startTime: "",
          endDate: "",
          endDatePayment: "",
          amount: 0,
          endTime: "",
          agendaType: 0,
          color: "#F22727",
          Time: 2,
          minutesHours: "h",
          fixed: true,
          invoiceType: "",
          SerieGroup: null,
          editionSerie: false
        };
      }
    },
    submitMode: {
      type: String
    },
    dialogFormVisible: {
      type: Boolean
    },
    rulesForDisablingSaveButton: {
      type: Boolean,
      default: false
    },
    rulesForDisablingDelete: {
      type: Boolean,
      default: false
    },
    eventSelectedIsTask: {
      type: Boolean,
      default: false
    },
    userIsSupervisor: {
      type: Boolean,
      default: false
    },
    currentlyChosenAgenda: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userId: {
      type: Number,
      default: function () {
        return this.$store.state.user.user.UserID;
      }
    },
    currentChosenCalendarID: {
      type: Number
    },
    prospect: {
      type: String
    },
    contact: {
      type: String
    },
    CurrentResponsableInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    // "quill-editor": quillEditor
    MinuteOurSelectoForTasks,
    TimeSelector,
    InvoiceType
  },
  data() {
    //let self = this;
    return {
      agendaTypeOptions: [
        {
          value: 0,
          label: "Evento"
        }
      ],
      amountoFormat: formatMonto(this.form.amount),
      submitModeOptions: {
        Add: "Agregar Facturación y Fecha de Pago",
        Edit: "Editar Fecha de Facturación",
        AddPayment: "Agregar Fecha de Pago",
        EditPayment: "Editar Fecha de Pago"
      },
      deleteConfirmationVisible: false,
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          time;
          return false;
          /*
          if (self.form.type) {
            return false;
          } else {
            return time.getMonth() > 0;
          }
          */
        }
      },
      pickerOptionsEdit: {
        disabledDate(time) {
          return time.getMonth() < 0;
        }
      },
      disableBtn: false
    };
  },
  computed: {
    formTitle() {
      if (this.currentlyChosenAgenda.event) {
        if (this.currentlyChosenAgenda.event.extendedProps.isTask) {
          return "Tarea";
        } else {
          return "Evento";
        }
      } else {
        return "Evento";
      }
    },
    calculateSwitches() {
      return this.submitMode == "Agregar Fecha de Pago" ||
        this.submitMode == "Editar Fecha de Pago"
        ? "Pagado?"
        : "Facturado?";
    }
    // IsMinuteHour() {
    //   let minuteHours;
    //   if (this.form.minutesHours === "m") {
    //     minuteHours = 480;
    //   } else {
    //     minuteHours = 8;
    //   }
    //   return minuteHours;
    // }
  },
  methods: {
    ...mapActions("calendarFinances", [
      "create",
      "update",
      "updateTaskInApi",
      "delete"
    ]),
    submitEvent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // this.$emit("submit-event", this.form);
          if (
            this.submitMode === this.submitModeOptions.Add ||
            this.submitMode === this.submitModeOptions.AddPayment
          ) {
            this.setEvent();
          } else if (
            this.submitMode === this.submitModeOptions.Edit ||
            this.submitMode === this.submitModeOptions.EditPayment
          ) {
            if (this.eventSelectedIsTask) {
              this.updateTask();
            } else if (!this.eventSelectedIsTask) {
              //("cono se fue por evento")
              this.updateEvent();
            }
          }
        }
      });
    },
    setEvent() {
      this.disableBtn = true;
      this.loading = true;

      let start = moment(this.form.endDate);
      if (this.form.startTime) {
        start.add(moment(this.form.startTime).format("HH"), "hours");
        start.add(moment(this.form.startTime).format("mm"), "minutes");
      }

      let event = {
        id: new Date().getTime(),
        title: this.form.title,
        description: this.form.description,
        start: start,
        allDay: this.form.allDay,
        paid: this.form.paid,
        agendaType: this.form.agendaType
        // responsible: this.form.responsible
      };

      if (this.form.color) event.color = this.form.color;
      if (this.form.endDate) {
        let end = moment(this.form.endDate);
        if (this.form.endTime) {
          end.add(moment(this.form.endTime).format("HH"), "hours");
          end.add(moment(this.form.endTime).format("mm"), "minutes");
        }
      }

      // if (this.form.type === false) {
      //   if (this.currentChosenCalendarID == 1) {
      //     for (var i = 0; i < 12; i++) {
      //       // alert("ok");
      //       this.create({
      //         CalendariosFP_ID: this.currentChosenCalendarID,
      //         CreatedBy: this.$store.state.user.user.UserID,
      //         Amount: this.form.amount,
      //         Content: event.description,
      //         // responsible: event.responsible,

      //         DateTime: moment(event.start)
      //           .add(i, "M")
      //           .format("YYYY-MM-DD HH:mm:ss"),
      //         // StarDate: event.start,
      //         StarDate: moment(this.form.endDate)
      //           .add(i, "M")
      //           .format("YYYY-MM-DD HH:mm:ss"),
      //         // EndDate: event.end,
      //         EndDate: moment(this.form.endDate)
      //           .add(i, "M")
      //           .format("YYYY-MM-DD HH:mm:ss"),
      //         Title: event.title,
      //         Description: event.description,
      //         AllDay: event.allDay,
      //         Paid: event.paid,
      //         Color: event.color,
      //         AgendaType: event.agendaType,
      //         TaskResponsibleId: this.CurrentResponsableInfo.Id
      //       })
      //         .then(() => {
      //           this.disableBtn = false;
      //           this.loading = false;
      //           this.closeEventDialog();
      //           this.$message.success("Evento creado exitosamente");
      //         })
      //         .catch((error) => {
      //           this.disableBtn = false;
      //           this.loading = false;
      //           this.closeEventDialog();
      //           this.$message.error("Error al crear evento ", error);
      //         });

      //       this.create({
      //         CalendariosFP_ID: 2,
      //         CreatedBy: this.$store.state.user.user.UserID,
      //         Content: event.description,
      //         // responsible: event.responsible,
      //         Amount: this.form.amount,
      //         DateTime: moment(this.form.endDatePayment)
      //           .add(i, "M")
      //           .format("YYYY-MM-DD HH:mm:ss"),
      //         // StarDate: event.start,
      //         StarDate: moment(this.form.endDatePayment)
      //           .add(i, "M")
      //           .format("YYYY-MM-DD HH:mm:ss"),
      //         // EndDate: event.end,
      //         EndDate: moment(this.form.endDatePayment)
      //           .add(i, "M")
      //           .format("YYYY-MM-DD HH:mm:ss"),
      //         Title: event.title,
      //         Description: event.description,
      //         AllDay: event.allDay,
      //         Paid: event.paid,
      //         Color: event.color,
      //         AgendaType: event.agendaType,
      //         TaskResponsibleId: this.CurrentResponsableInfo.Id
      //       })
      //         .then(() => {
      //           this.disableBtn = false;
      //           this.loading = false;
      //           this.closeEventDialog();
      //           this.$message.success("Evento creado exitosamente");
      //         })
      //         .catch((error) => {
      //           this.disableBtn = false;
      //           this.loading = false;
      //           this.closeEventDialog();
      //           this.$message.error("Error al crear evento: ", error);
      //         });
      //     }
      //     return;
      //   }
      //   for (i = 0; i < 12; i++) {
      //     this.create({
      //       CalendariosFP_ID: this.currentChosenCalendarID,
      //       CreatedBy: this.$store.state.user.user.UserID,
      //       Content: event.description,
      //       //  responsible: event.responsible,
      //       Amount: this.form.amount,
      //       DateTime: moment(this.form.endDatePayment)
      //         .add(i, "M")
      //         .format("YYYY-MM-DD HH:mm:ss"),
      //       // StarDate: event.start,
      //       StarDate: moment(this.form.endDatePayment)
      //         .add(i, "M")
      //         .format("YYYY-MM-DD HH:mm:ss"),
      //       // EndDate: event.end,
      //       EndDate: moment(this.form.endDatePayment)
      //         .add(i, "M")
      //         .format("YYYY-MM-DD HH:mm:ss"),
      //       Title: event.title,
      //       Description: event.description,
      //       AllDay: event.allDay,
      //       Paid: event.paid,
      //       Color: event.color,
      //       AgendaType: event.agendaType,
      //       TaskResponsibleId: this.CurrentResponsableInfo.Id
      //     })
      //       .then(() => {
      //         this.disableBtn = false;
      //         this.loading = false;
      //         this.closeEventDialog();
      //         this.$message.success("Evento creado exitosamente");
      //       })
      //       .catch((error) => {
      //         this.disableBtn = false;
      //         this.loading = false;
      //         this.closeEventDialog();
      //         this.$message.error("Error al crear evento ", error);
      //       });
      //   }
      // } else {
      this.create({
        CalendariosFP_ID: this.currentChosenCalendarID,
        CreatedBy: this.$store.state.user.user.UserID,
        Amount: this.form.amount,
        Content: event.description,
        //  responsible: event.responsible,
        DateTime: moment(event.start).format("YYYY-MM-DD HH:mm:ss"),
        // StarDate: event.start,
        StarDate: moment(this.form.endDate).format("YYYY-MM-DD HH:mm:ss"),
        // EndDate: event.end,
        EndDate: moment(this.form.endDate).format("YYYY-MM-DD HH:mm:ss"),
        Title: event.title,
        Description: event.description,
        AllDay: event.allDay,
        Paid: event.paid,
        Color: event.color,
        AgendaType: event.agendaType,
        TaskResponsibleId: this.CurrentResponsableInfo.Id,
        recurrente: !this.form.type,
        TimeEstimated: this.form.Time,
        MinuteHour: this.form.minutesHours,
        IsFixed: this.form.fixed,
        invoiceType: this.form.invoiceType
      })
        .then(() => {
          this.disableBtn = false;
          this.loading = false;
          this.closeEventDialog();
          this.$message.success("Evento creado exitosamente");
        })
        .catch((error) => {
          this.disableBtn = false;
          this.loading = false;
          this.closeEventDialog();
          this.$message.error("Error al crear evento ", error);
        });

      this.create({
        CalendariosFP_ID: 2,
        CreatedBy: this.$store.state.user.user.UserID,
        Content: event.description,
        //  responsible: event.responsible,
        Amount: this.form.amount,
        DateTime: moment(this.form.endDatePayment).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        // StarDate: event.start,
        StarDate: moment(this.form.endDatePayment).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        // EndDate: event.end,
        EndDate: moment(this.form.endDatePayment).format("YYYY-MM-DD HH:mm:ss"),
        Title: event.title,
        Description: event.description,
        AllDay: event.allDay,
        Paid: event.paid,
        Color: event.color,
        AgendaType: event.agendaType,
        TaskResponsibleId: this.CurrentResponsableInfo.Id,
        recurrente: !this.form.type,
        TimeEstimated: this.form.Time,
        MinuteHour: this.form.minutesHours,
        IsFixed: this.form.fixed,
        invoiceType: this.form.invoiceType
      })
        .then(() => {
          this.disableBtn = false;
          this.loading = false;
          this.closeEventDialog();
          this.$message.success("Evento creado exitosamente");
        })
        .catch((error) => {
          this.disableBtn = false;
          this.loading = false;
          this.closeEventDialog();
          this.$message.error("Error al crear evento ", error);
        });
      // }
    },
    updateEvent() {
      this.loading = true;

      let event = {
        id: new Date().getTime(),
        title: this.form.title,
        description: this.form.description,
        amount: this.form.amount,
        allDay: this.form.allDay,
        paid: this.form.paid,
        start: {},
        end: {},
        agendaType: this.form.agendaType,
        TimeEstimated: this.form.Time,
        MinuteHour: this.form.minutesHours,
        IsFixed: this.form.fixed,
        invoiceType: this.form.invoiceType,
        SerieGroup: this.form.SerieGroup,
        editionSerie: this.form.editionSerie
      };

      if (this.form.color) event.color = this.form.color;

      let currentEndDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.endDate
      );
      let newEndDate = new Date(this.form.endDate);
      let newEndTime = new Date(this.form.endTime);

      let currentStartDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.endDate
      );
      let newStartDate = new Date(this.form.endDate);
      let newStartTime = new Date(this.form.startTime);

      // Change start hours and minutes

      if (
        currentStartDate.getHours() != newStartTime.getHours() ||
        currentStartDate.getMinutes() != newStartTime.getMinutes()
      ) {
        newStartDate.setHours(newStartTime.getHours());
        newStartDate.setMinutes(newStartTime.getMinutes());
      }

      let start = moment(newStartDate);
      event.start = start;

      // Change end hours and minutes
      if (
        currentEndDate.getHours() != newEndTime.getHours() ||
        currentEndDate.getMinutes() != newEndTime.getMinutes()
      ) {
        newEndDate.setHours(newEndTime.getHours());
        newEndDate.setMinutes(newEndTime.getMinutes());
      }

      let end = moment(newEndDate);
      event.end = end;

      event.end =
        this.submitMode == "Editar Fecha de Facturación"
          ? this.form.endDate
          : this.form.endDatePayment;

      event.start = event.start.format();

      this.update({
        CalendarioID: this.currentChosenCalendarID,
        CreatedBy: this.currentlyChosenAgenda.event.extendedProps.createdBy,
        Content: event.description,
        Amount: event.amount,
        // DateTime: event.end,end
        DateTime: moment(event.end).format("YYYY-MM-DD HH:mm:ss"),
        // StarDate: event.end,
        StarDate: moment(event.end).format("YYYY-MM-DD HH:mm:ss"),
        // EndDate: event.end,
        EndDate: moment(event.end).format("YYYY-MM-DD HH:mm:ss"),
        Title: event.title,
        Description: event.description,
        AllDay: event.allDay,
        Paid: event.paid,
        Color: event.color,
        Id: this.currentlyChosenAgenda.event.id,
        AgendaType: event.agendaType,
        TaskResponsibleId: this.CurrentResponsableInfo.Id,
        TimeEstimated: event.TimeEstimated,
        MinuteHour: event.MinuteHour,
        IsFixed: event.IsFixed,
        invoiceType: event.invoiceType,
        SerieGroup: event.SerieGroup,
        EditionSerie: event.editionSerie
      })
        .then(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.success("Evento modificado exitosamente");
        })
        .catch(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.error("Error al modificar evento");
        });
    },
    updateTask() {
      this.loading = true;

      let event = {
        id: new Date().getTime(),
        title: this.form.title,
        description: this.form.description,
        allDay: this.form.allDay,
        paid: this.form.paid,
        start: {},
        end: {}
      };

      if (this.form.color) event.color = this.form.color;

      let currentEndDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.endDate
      );
      let newEndDate = new Date(this.form.endDate);
      let newEndTime = new Date(this.form.endTime);

      let currentStartDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.startDate
      );
      let newStartDate = new Date(this.form.startDate);
      let newStartTime = new Date(this.form.startTime);

      // Change start hours and minutes
      if (
        currentStartDate.getHours() != newStartTime.getHours() ||
        currentStartDate.getMinutes() != newStartTime.getMinutes()
      ) {
        newStartDate.setHours(newStartTime.getHours());
        newStartDate.setMinutes(newStartTime.getMinutes());
      }

      let start = moment(newStartDate);
      event.start = start;

      // Change end hours and minutes
      if (
        currentEndDate.getHours() != newEndTime.getHours() ||
        currentEndDate.getMinutes() != newEndTime.getMinutes()
      ) {
        newEndDate.setHours(newEndTime.getHours());
        newEndDate.setMinutes(newEndTime.getMinutes());
      }

      let end = moment(newEndDate);
      event.end = end;

      event.end = event.end.format();
      event.start = event.start.format();

      this.updateTaskInApi({
        ObjetiveID: this.currentlyChosenAgenda.event.extendedProps.objectiveId,
        Id: this.currentlyChosenAgenda.event.id,
        Description: event.description,
        Name: this.currentlyChosenAgenda.event.extendedProps.originalTitle,
        ResponsableId: this.CurrentResponsableInfo.Id,
        LimiteDate: event.end,
        CompanySelected: this.currentCompany,
        Percentage: this.currentlyChosenAgenda.event.extendedProps.percentage,
        TimeEstimated: this.form.Time,
        MinuteHour: this.form.minutesHours,
        IsFixed: this.form.fixed,
        invoiceType: this.form.invoiceType,
        editionSerie: this.form.editionSerie
      })
        .then(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.success("Tarea modificada exitosamente");
        })
        .catch(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.error("Error al modificar tarea");
        });
    },
    async handleDeleteEvent() {
      try {
        this.loading = true;
        await this.delete({
          AgendaID: this.currentlyChosenAgenda.event.id,
          UserId: this.userId,
          CalendariosFP_ID: this.currentChosenCalendarID,
          Paid: this.form.paid,
          Title: this.form.title,
          SerieGroup: this.form.SerieGroup,
          EditionSerie: this.form.editionSerie
        });
        this.$message.success("Evento eliminado exitosamente");
      } catch (error) {
        console.error("Error al eliminar evento:", error);
        this.loading = false;
        this.closeEventDialog();
        this.closeDeleteDialog();
        this.$message.error("Error al eliminar evento");
      } finally {
        this.loading = false;
        this.closeEventDialog();
        this.closeDeleteDialog();
      }
    },
    closeEventDialog() {
      this.$emit("close-event-dialog");
      this.$refs["form"].resetFields();
      this.form.title = "";
      this.form.description = "";
      this.form.allDay = true;
      this.form.paid = false;
      this.form.startDate = "";
      this.form.startTime = "";
      this.form.endDate = "";
      this.form.endTime = "";
      this.form.agendaType = 0;
      this.form.color = "#F22727";
      this.form.Time = 0;
      this.form.minutesHours = "m";
      this.form.invoiceType = "";
    },
    openDeleteDialog() {
      this.deleteConfirmationVisible = true;
    },
    closeDeleteDialog() {
      this.deleteConfirmationVisible = false;
    },
    onSwitchChange(/*type*/) {},
    // OnEmployeeSelected(employee) {
    //   this.form.responsible = employee;
    // },
    MinuteHoureChanged(minuteHours) {
      this.form.minutesHours = minuteHours;
      // if (minuteHours === "h" && this.form.Time > 8) {
      //   this.form.Time = 8;
      // }
    },
    onFixedChange(val) {
      this.form.fixed = val;
    },
    onTimeSelected(time) {
      this.form.Time = time;
    },
    OnInvoiceTypeSelected(type) {
      this.form.invoiceType = type;
    }
  },
  watch: {
    prospect(newProspect) {
      if (newProspect) {
        this.form.title = `Cita - ${newProspect}`;
        this.form.agendaType = 1; // Cita
      }
    },
    form: {
      handler: function (value) {
        this.amountoFormat = formatMonto(value.amount);
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.inputAmount {
  border-radius: 5px solid #e4e7ed;
  height: 30px;
  border-color: 1px solid #e4e7ed;
}
</style>
